import { PropsWithChildren, Children, isValidElement, ReactNode } from "react";
import { OptionProps, Option } from "../Option";
import { GroupProps, Group } from "../Group";

/**
 * An option item.
 */
export interface OptionItem extends PropsWithChildren<OptionProps> {
  /**
   * The item type.
   */
  readonly type: "option";
}

/**
 * A group item.
 */
export interface GroupItem extends GroupProps {
  /**
   * The item type.
   */
  readonly type: "group";
}

/**
 * The child item type.
 */
export type ChildItem = OptionItem | GroupItem;

/**
 * Gets the items from the specified children.
 * @param children The children to get the items from.
 * @returns The array of items.
 */
export function getItems(children: ReactNode | undefined): ReadonlyArray<ChildItem> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;

      if (child.type === Option) {
        return { ...child.props, type: "option" } as OptionItem;
      } else if (child.type === Group) {
        return { ...child.props, type: "group" } as GroupItem;
      }

      console.log("CheckboxGroup ignoring unsupported child component.");
      return null;
    })?.filter((option) => !!option) ?? []
  );
}
